<template>
  <el-dialog
    title="入驻记录详情"
    :visible.sync="open_detail"
    width="70%"
    :before-close="handleClose"
  >
    <div class="detail-container">
      <!-- 基本信息 -->
      <el-card class="box-card" shadow="never">
        <div slot="header" class="clearfix">
          <span class="card-title">基本信息</span>
        </div>
        <el-row :gutter="20">
          <el-col :span="8">
            <div class="detail-item">
              <label>入驻记录ID：</label>
              <span>{{ form.settled_log_id }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="detail-item">
              <label>申请角色：</label>
              <span>{{ form.user_role_name }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="detail-item">
              <label>用户ID：</label>
              <span>{{ form.user_id }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="detail-item">
              <label>联系电话：</label>
              <span>{{ form.phone || '未填写' }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="detail-item">
              <label>身份证号：</label>
              <span>{{ form.id_code || '未填写' }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="detail-item">
              <label>审核状态：</label>
              <el-tag :type="getStatusType(form.status)">
                {{ getStatusText(form.status) }}
              </el-tag>
            </div>
          </el-col>
   
      
        </el-row>
      </el-card>

      <!-- 用户信息 -->
      <el-card class="box-card" shadow="never" style="margin-top: 20px;">
        <div slot="header" class="clearfix">
          <span class="card-title">用户信息</span>
        </div>
        <el-row :gutter="20">
          <el-col :span="8">
            <div class="detail-item">
              <label>昵称：</label>
              <span>{{ form.nickName || '未设置' }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="detail-item">
              <label>手机号：</label>
              <span>{{ form.mobile || '未绑定' }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="detail-item">
              <label>用户编号：</label>
              <span>{{ form.user_no || '无' }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="detail-item">
              <label>当前用户角色：</label>
              <span>{{ form.role || 'user' }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="detail-item">
              <label>余额：</label>
              <span>¥{{ form.balance || '0.00' }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="detail-item">
              <label>累计消费：</label>
              <span>¥{{ form.expend_money || '0.00' }}</span>
            </div>
          </el-col>
        </el-row>
      </el-card>

      <!-- 证件信息 -->
      <el-card class="box-card" shadow="never" style="margin-top: 20px;">
        <div slot="header" class="clearfix">
          <span class="card-title">证件信息</span>
        </div>
        <el-row :gutter="20">
          <el-col :span="8">
            <div class="detail-item">
              <label>身份证正面：</label>
              <div v-if="form.idcard_front" class="image-preview">
                <el-image 
                  :src="form.idcard_front" 
                  :preview-src-list="[form.idcard_front]"
                  style="width: 100px; height: 70px;"
                  fit="cover"
                ></el-image>
              </div>
              <span v-else>未上传</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="detail-item">
              <label>身份证反面：</label>
              <div v-if="form.idcard_back" class="image-preview">
                <el-image 
                  :src="form.idcard_back" 
                  :preview-src-list="[form.idcard_back]"
                  style="width: 100px; height: 70px;"
                  fit="cover"
                ></el-image>
              </div>
              <span v-else>未上传</span>
            </div>
          </el-col>
          <!-- <el-col :span="8">
            <div class="detail-item">
              <label>个人照片：</label>
              <div v-if="form.personalPhoto" class="image-preview">
                <el-image 
                  :src="form.personalPhoto" 
                  :preview-src-list="[form.personalPhoto]"
                  style="width: 100px; height: 70px;"
                  fit="cover"
                ></el-image>
              </div>
              <span v-else>未上传</span>
            </div>
          </el-col> -->
          <el-col :span="8">
            <div class="detail-item">
              <label>其他证书：</label>
              <div v-if="form.otherCert" class="image-preview">
                <el-image 
                  :src="form.otherCert" 
                  :preview-src-list="[form.otherCert]"
                  style="width: 100px; height: 70px;"
                  fit="cover"
                ></el-image>
              </div>
              <span v-else>未上传</span>
            </div>
          </el-col>
         
        </el-row>
      </el-card>

    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">关 闭</el-button>
      <el-button v-if="form.status === 0" type="primary" @click="handleEdit">审核</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    open_detail: {
      type: Boolean,
      default: false
    },
    form: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    /*关闭弹窗*/
    handleClose() {
      this.$emit('closeDialog', {
        openDialog: false,
        type: 'close'
      });
    },

    /*跳转到编辑*/
    handleEdit() {
      this.handleClose();
      // 这里可以触发父组件的编辑操作
      this.$emit('editRecord', this.form);
    },

    /*状态文本转换*/
    getStatusText(status) {
      const statusMap = {
        0: '待审核',
        1: '审核通过',
        2: '审核拒绝'
      };
      return statusMap[status] || '未知状态';
    },

    /*状态类型*/
    getStatusType(status) {
      const typeMap = {
        0: 'warning',
        1: 'success',
        2: 'danger'
      };
      return typeMap[status] || 'info';
    },

    /*时间格式化*/
    formatTime(timestamp) {
      if (!timestamp) return '';
      const date = new Date(timestamp * 1000);
      return date.toLocaleString();
    }
  }
};
</script>

<style scoped>
.detail-container {
  max-height: 70vh;
  overflow-y: auto;
}

.box-card {
  margin-bottom: 0;
}

.card-title {
  font-weight: bold;
  font-size: 16px;
}

.detail-item {
  margin-bottom: 15px;
  display: flex;
  align-items: flex-start;
}

.detail-item label {
  font-weight: bold;
  color: #606266;
  min-width: 100px;
  text-align: right;
  margin-right: 10px;
}

.detail-item span {
  flex: 1;
  word-break: break-all;
}

.image-preview {
  margin-top: 5px;
}

.text-overflow {
  display: inline-block;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: bottom;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}
</style>


// WEBPACK FOOTER //
// src/views/user/setting/part/Detail.vue